import React, { useEffect, useRef, useState } from "react";
import PaiAnimationBg from "components/PaiAnimationBg";
import {PAI_ANIMATION_BG_TYPE} from "components/PaiAnimationBg/constants";
// import {Image} from "antd";

const HomeBanner: React.FC = () => {
    const bannerRef: any = useRef(null)
    const [bannerContainerHeight, setBannerContainerHeight] = useState(0)

    useEffect(() => {
        if (bannerRef?.current) {
            const { clientHeight = 0 } = bannerRef.current
            setBannerContainerHeight(clientHeight)
        }
    }, [bannerRef?.current])

    console.log('bannerContainerHeight', bannerContainerHeight)

    return (
        <div ref={bannerRef} className={'banner'}>
            <div className="banner-bg">
                <PaiAnimationBg
                    type={PAI_ANIMATION_BG_TYPE.PARTICLE_BG}
                    height={bannerContainerHeight}
                />
            </div>
            <div className="backdrop-filter" />
            <div className={'title-container'}>
                <div className={'title'}>派点软件信息技术服务中心</div>
                {/*<div className={'sub-title'}>从点起步，延伸成线，继而拓展为面。就从当下这一关键之「点」出发，运用无穷的技术，编织出如圆周率「π」一般丰富多元的项目。*/}
                {/*</div>*/}
                <div className={'sub-title'}>从点到线再到面，从此刻的那一「点」出发，用无限技术编织如「π」般丰富多元的项目。</div>
                {/*<Image src={'https://test-hiter-1321997304.cos.ap-beijing.myqcloud.com/fengmian.jpg'}/>*/}
            </div>
        </div>
    )
}

export default React.memo(HomeBanner)